/*
 * @Author: liujunhong
 * @Date: 2022-12-08
 * @Desc:
 */

export default {
  state: {
    updateLogin: {},
    loginStatus: {}
  },
  reducers: {
    setUpdateLogin(state, payload) {
      return {...state, updateLogin: payload}
    },
    setLoginStatus(state, payload) {
      return {...state, loginStatus: payload}
    }
  },
  effects: (dispatch) => ({}),
};